import type {TuiCountryIsoCode, TuiLanguage, TuiLanguageCommerce, TuiLanguageCore, TuiLanguageEditor, TuiLanguageKit, TuiLanguageLayout, TuiLanguageTable} from '@taiga-ui/i18n/types';

export const TUI_SERBIAN_LANGUAGE_ADDON_COMMERCE: TuiLanguageCommerce = {
    cardNumber: ['Број', 'Број картице'],
    cardExpiry: ['Истиче', 'Датум истека'],
};

export const TUI_SERBIAN_LANGUAGE_LAYOUT: TuiLanguageLayout = {
    inputSearch: {
        popular: 'Популарно',
        history: 'Недавно',
        placeholder: 'Претрага',
        hotkey: 'за претрагу',
        all: 'Све',
        empty: 'Нема резултата',
    },
};

export const TUI_SERBIAN_LANGUAGE_KIT: TuiLanguageKit = {
    cancel: 'Откажи',
    done: 'Готово',
    more: 'Више',
    otherDate: 'Други датум...',
    showAll: 'Прикажи све',
    hide: 'Сакриј',
    mobileCalendarTexts: [
        'Изабери дан',
        'Изабери период',
        'Изабери дане',
    ],
    range: ['Од', 'До'],
    countTexts: ['Више', 'Мање'],
    time: {
        'HH:MM': 'HH:MM',
        'HH:MM AA': 'HH:MM AA',
        'HH:MM:SS': 'HH:MM:SS',
        'HH:MM:SS AA': 'HH:MM:SS AA',
        'HH:MM:SS.MSS': 'HH:MM:SS.MSS',
        'HH:MM:SS.MSS AA': 'HH:MM:SS.MSS AA',
    },
    dateTexts: {
        DMY: 'дан.месец.година',
        MDY: 'месец.дан.година',
        YMD: 'година.месец.дан',
    },
    digitalInformationUnits: ['Бајт', 'Килобајт', 'Мегабајт'],
    passwordTexts: ['Прикажи лозинку', 'Сакриј лозинку'],
    copyTexts: ['Копирај', 'Копирано'],
    shortCalendarMonths: [
        'Јан',
        'Феб',
        'Мар',
        'Апр',
        'Мај',
        'Јун',
        'Јул',
        'Авг',
        'Сеп',
        'Окт',
        'Нов',
        'Дец',
    ],
    pagination: ['Претходна страница', 'Следећа страница'],
    fileTexts: {
        loadingError: 'Грешка при учитавању',
        preview: 'Преглед',
        remove: 'Уклони',
    },
    inputFileTexts: {
        defaultLabelSingle: 'или превуци овде',
        defaultLabelMultiple: 'или превуци овде',
        defaultLinkSingle: 'Изабери фајл',
        defaultLinkMultiple: 'Изабери фајлове',
        maxSizeRejectionReason: 'Фајл је превелик',
        formatRejectionReason: 'Неисправан формат фајла',
        drop: 'Превуци фајл овде',
        dropMultiple: 'Превуци фајлове овде',
    },
    multiSelectTexts: {
        all: 'Изабери све',
        none: 'Не изабери ништа',
    },
    confirm: {
        yes: 'Да',
        no: 'Не',
    },
    previewTexts: {
        rotate: 'Ротирај',
    },
    zoomTexts: {
        zoomOut: 'Умањи',
        zoomIn: 'Увеличи',
        reset: 'Ресетуј',
    },
    phoneSearch: 'Претражи земљу или код',
};

export const TUI_SERBIAN_LANGUAGE_ADDON_EDITOR: TuiLanguageEditor = {
    colorSelectorModeNames: ['Једнобојно', 'Бојни градијент'],
    toolbarTools: {
        undo: 'Поништи',
        redo: 'Понови',
        font: 'Фонт',
        fontStyle: 'Стил фонта',
        fontSize: 'Величина фонта',
        bold: 'Подебљано',
        italic: 'Курзив',
        underline: 'Подвучено',
        strikeThrough: 'Прецртано',
        justify: 'Поравнање',
        justifyLeft: 'Поравнај лево',
        justifyCenter: 'Центрирај',
        justifyRight: 'Поравнај десно',
        justifyFull: 'Поравнај обастрано',
        list: 'Листа',
        indent: 'Увећај увлачење',
        outdent: 'Смањи увлачење',
        unorderedList: 'Неуређена листа',
        orderedList: 'Уређена листа',
        quote: 'Цитат',
        foreColor: 'Боја текста',
        backColor: 'Боја позадине',
        hiliteColor: 'Боја истакнутости',
        clear: 'Очисти',
        link: 'Линк',
        attach: 'Приложи фајл',
        tex: 'Убаци TeX',
        code: 'Код',
        image: 'Убаци слику',
        insertHorizontalRule: 'Убаци хоризонталну линију',
        superscript: 'Натпис',
        subscript: 'Потпис',
        insertTable: 'Убаци табелу',
        insertGroup: 'Убаци групу',
        hiliteGroup: 'Истакни групу',
        removeGroup: 'Уклони групу',
        insertAnchor: 'Убаци сидро',
        mergeCells: 'Споји ћелије',
        splitCells: 'Подели ћелије',
        rowsColumnsManaging: 'Управљање редовима и колонама',
        cellColor: 'Боја ћелије',
        setDetails: 'Постави детаље',
        removeDetails: "Уклони детаље",
    },
    editorEditLink: {
        urlExample: 'пример.com',
        anchorExample: 'сидро',
    },
    editorTableCommands: [
        ['Убаци колону пре', 'Убаци колону после'],
        ['Убаци ред пре', 'Убаци ред после'],
        ['Уклони колону', 'Уклони ред'],
    ],
    editorCodeOptions: ['Код у тексту', 'Блок кода'],
    editorFontOptions: {
        small: 'Мало',
        large: 'Велико',
        normal: 'Нормално',
        title: 'Наслов',
        subtitle: 'Поднаслов',
    },
};

export const TUI_SERBIAN_LANGUAGE_ADDON_TABLE: TuiLanguageTable = {
    showHideText: 'Прикажи/Сакриј',
    paginationTexts: {
        pages: 'Странице',
        linesPerPage: 'Редова по страници',
        of: 'од',
    },
};

export const TUI_SERBIAN_LANGUAGE_CORE: TuiLanguageCore = {
    months: [
        'Јануар',
        'Фебруар',
        'Март',
        'Април',
        'Мај',
        'Јун',
        'Јул',
        'Август',
        'Септембар',
        'Октобар',
        'Новембар',
        'Децембар',
    ],
    close: 'Затвори',
    clear: 'Очисти',
    nothingFoundMessage: 'Нема резултата',
    defaultErrorMessage: 'Неисправна вредност',
    spinTexts: ['Претходни', 'Следећи'],
    shortWeekDays: ['Пон', 'Уто', 'Сре', 'Чет', 'Пет', 'Суб', 'Нед'],
    countries: {} as Record<TuiCountryIsoCode, string>,
};

export const TUI_SERBIAN_LANGUAGE: TuiLanguage = {
    name: 'serbian',
    ...TUI_SERBIAN_LANGUAGE_CORE,
    ...TUI_SERBIAN_LANGUAGE_KIT,
    ...TUI_SERBIAN_LANGUAGE_ADDON_TABLE,
    ...TUI_SERBIAN_LANGUAGE_ADDON_COMMERCE,
    ...TUI_SERBIAN_LANGUAGE_ADDON_EDITOR,
    ...TUI_SERBIAN_LANGUAGE_LAYOUT,
};